import {
  getPageResumeQuery,
  getPagePreviewResumeQuery,
} from '@redlink/services';

export const freshCache =
  ({ pageName }) =>
  (cache, { data }) => {
    freshResume({ cache, data });
    freshPreviewResume({ cache, data, pageName });
  };
const freshResume = ({ cache, data }) => {
  let {
    Resume: { projects, ...rest },
  } = cache.readQuery({
    query: getPageResumeQuery,
  });

  cache.writeQuery({
    query: getPageResumeQuery,
    data: {
      Resume: {
        projects: data.EditResumeProjects,
        ...rest,
      },
    },
  });
};

const freshPreviewResume = ({ cache, data, pageName }) => {
  try {
    let {
      ResumePreview: { projects, ...rest },
    } = cache.readQuery({
      query: getPagePreviewResumeQuery,
      variables: { pageName },
    });

    cache.writeQuery({
      query: getPagePreviewResumeQuery,
      data: {
        ResumePreview: {
          projects: data.EditResumeProjects,
          ...rest,
        },
      },
      variables: { pageName },
    });
  } catch (e) {}
};
